import { makeStyles, createStyles } from '@material-ui/core'

export const useConfirmModalStyles = makeStyles((theme) =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1)
    },

    buttons: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',

      '& > button:last-child': {
        marginLeft: 20
      }
    }
  })
)
